import {APP_API_URL} from "../../../../settings";

const token = localStorage.getItem('token');
export const getWithdrawHistory = async () => {
    const reqOpt = {
        method: 'GET',
        headers: {
            "X-Access-Token": token,
        },
    };
    return fetch(APP_API_URL + "/photoframe-mobile/finance/withdraw/balance/history", reqOpt)
        .then(response => response.json())
        .then(res => res.result)
        .catch(error => console.log('error', error));
}